import { actionGenerator, ITypedReduxAction } from 'shared/utils/redux/actionGenerator';

export enum EFavoriteOffersActionTypes {
  UpdateFavorite = 'offers/favorite/FAVORITE_CHANGED',
}

interface IUpdateFavoritePayload {
  offerId: number;
  isFavorite: boolean;
}

export interface IFavoriteChangedAction {
  type: EFavoriteOffersActionTypes.UpdateFavorite;
  payload: IUpdateFavoritePayload;
}

export const updateFavorite = actionGenerator<EFavoriteOffersActionTypes.UpdateFavorite, IUpdateFavoritePayload>(
  EFavoriteOffersActionTypes.UpdateFavorite,
);

export type TUpdateFavorite = ITypedReduxAction<EFavoriteOffersActionTypes.UpdateFavorite, IUpdateFavoritePayload>;

export type TFavoriteOfferActions = TUpdateFavorite;
